import { TimeToMarketScoreCard } from './TimeToMarketScoreCard';

export const DevOpsMetricsComponent = (): JSX.Element => {
  return <TimeToMarketScoreCard />;
};
